import type { Room } from '@hollowveil/shared';

export const roomMiddleEarth: Room = {
  id: 'room_middle_earth',
  name: "Terre du Milieu - La Comté",
  description: "Les collines verdoyantes de la Comté, patrie des Hobbits. Mais l'ombre de Mordor s'étend...",
  size: [24, 10, 24],
  floorStyle: 'grass',
  ambiance: {
    realWorld: {
      backgroundColor: '#87CEEB',
      ambientLightColor: '#FFFACD',
      ambientLightIntensity: 0.85,
    },
    spectralWorld: {
      // Mordor - sombre, rouge, menaçant
      backgroundColor: '#1a0a0a',
      ambientLightColor: '#4a2a1a',
      ambientLightIntensity: 0.15,
      fogColor: '#2a1a0a',
      fogDensity: 0.08,
    },
  },
  objects: [
    // === MAISONS HOBBITS ===
    {
      id: 'obj_hobbit_hole_1',
      name: 'Cul-de-Sac',
      type: 'interactive',
      modelId: 'hobbit_hole',
      position: [6, 0, 6],
      rotation: [0, 0.3, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Cul-de-Sac, la demeure de Bilbon et Frodon Sacquet. Une maison de hobbit confortable.",
          },
        },
      ],
    },
    {
      id: 'obj_hobbit_hole_2',
      name: 'Maison de Sam',
      type: 'static',
      modelId: 'hobbit_hole',
      position: [10, 0, 4],
      rotation: [0, -0.2, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },
    {
      id: 'obj_hobbit_hole_3',
      name: 'Maison Hobbit',
      type: 'static',
      modelId: 'hobbit_hole',
      position: [16, 0, 5],
      rotation: [0, 0.5, 0],
      scale: [1.3, 1.3, 1.3],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // === L'ANNEAU UNIQUE ===
    {
      id: 'obj_the_ring',
      name: 'L\'Anneau Unique',
      type: 'interactive',
      modelId: 'the_one_ring',
      position: [12, 0.5, 12],
      rotation: [0, 0, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Un Anneau pour les gouverner tous, Un Anneau pour les trouver, Un Anneau pour les amener tous et dans les ténèbres les lier...",
          },
        },
      ],
    },

    // === ARBRES ET NATURE ===
    {
      id: 'obj_party_tree',
      name: 'Arbre de la Fête',
      type: 'interactive',
      modelId: 'ancient_tree',
      position: [8, 0, 10],
      rotation: [0, 0, 0],
      scale: [1.8, 2, 1.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Le grand Arbre de la Fête, sous lequel Bilbon a fait son discours d'adieu mémorable.",
          },
        },
      ],
    },
    {
      id: 'obj_tree_1',
      name: 'Chêne',
      type: 'static',
      modelId: 'tree',
      position: [4, 0, 16],
      rotation: [0, 0.8, 0],
      scale: [1.4, 1.6, 1.4],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },
    {
      id: 'obj_tree_2',
      name: 'Chêne',
      type: 'static',
      modelId: 'tree',
      position: [20, 0, 8],
      rotation: [0, 1.5, 0],
      scale: [1.3, 1.5, 1.3],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // === STATUE ELFIQUE ===
    {
      id: 'obj_elvish_statue',
      name: 'Statue Elfique',
      type: 'interactive',
      modelId: 'elvish_statue',
      position: [18, 0, 16],
      rotation: [0, -0.5, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Une statue elfique antique. L'étoile d'Eärendil brille à son sommet.",
          },
        },
      ],
    },

    // === MONDE SPECTRAL - MORDOR ===

    // Tour de Sauron
    {
      id: 'obj_barad_dur',
      name: 'Barad-dûr',
      type: 'interactive',
      modelId: 'barad_dur',
      position: [20, 0, 20],
      rotation: [0, -Math.PI / 4, 0],
      scale: [0.8, 0.8, 0.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Barad-dûr, la Tour Sombre de Sauron. L'Œil vous observe...",
          },
        },
      ],
    },

    // L'Œil de Sauron - animé, scrute la salle
    {
      id: 'obj_eye_of_sauron',
      name: "L'Œil de Sauron",
      type: 'static',
      modelId: 'eye_of_sauron',
      position: [20, 7.5, 20],
      rotation: [0, -Math.PI / 4, 0],
      scale: [0.8, 0.8, 0.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Mont du Destin
    {
      id: 'obj_mount_doom',
      name: 'Mont du Destin',
      type: 'interactive',
      modelId: 'mount_doom',
      position: [22, 0, 12],
      rotation: [0, 0.5, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Orodruin, le Mont du Destin. C'est ici que l'Anneau a été forgé, et c'est ici qu'il doit être détruit.",
          },
        },
      ],
    },

    // === MONTAGNES SOMBRES DE MORDOR ===
    {
      id: 'obj_dark_mountain_1',
      name: 'Montagne Sombre',
      type: 'static',
      modelId: 'dark_mountain',
      position: [0, 0, 22],
      rotation: [0, 0.3, 0],
      scale: [2, 2.5, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_dark_mountain_2',
      name: 'Montagne Sombre',
      type: 'static',
      modelId: 'dark_mountain',
      position: [8, 0, 23],
      rotation: [0, -0.2, 0],
      scale: [1.8, 2.2, 1.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_dark_mountain_3',
      name: 'Montagne Sombre',
      type: 'static',
      modelId: 'dark_mountain',
      position: [23, 0, 6],
      rotation: [0, 0.8, 0],
      scale: [1.5, 1.8, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_dark_mountain_4',
      name: 'Ephel Dúath',
      type: 'static',
      modelId: 'dark_mountain',
      position: [23, 0, 0],
      rotation: [0, 1.2, 0],
      scale: [2.2, 2.8, 2.2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_dark_mountain_5',
      name: 'Montagne Sombre',
      type: 'static',
      modelId: 'dark_mountain',
      position: [0, 0, 0],
      rotation: [0, -0.5, 0],
      scale: [1.6, 2, 1.6],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Minas Tirith au loin
    {
      id: 'obj_minas_tirith',
      name: 'Minas Tirith',
      type: 'interactive',
      modelId: 'minas_tirith',
      position: [4, 0, 20],
      rotation: [0, 0.3, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Minas Tirith, la Cité Blanche du Gondor. Le dernier bastion des Hommes.",
          },
        },
      ],
    },

    // Marais des Morts
    {
      id: 'obj_dead_marshes',
      name: 'Marais des Morts',
      type: 'interactive',
      modelId: 'dead_marshes',
      position: [12, 0, 18],
      rotation: [0, 0, 0],
      scale: [2, 1, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Les Marais des Morts... Ne suivez pas les lumières !",
          },
        },
      ],
    },

    // Arbres morts pour Mordor
    {
      id: 'obj_dead_tree_mordor_1',
      name: 'Arbre Mort',
      type: 'static',
      modelId: 'dead_tree',
      position: [8, 0, 10],
      rotation: [0.1, 0.5, 0],
      scale: [1.5, 1.8, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_dead_tree_mordor_2',
      name: 'Arbre Calciné',
      type: 'static',
      modelId: 'dead_tree',
      position: [16, 0, 8],
      rotation: [0, 1.2, 0.05],
      scale: [1.3, 1.5, 1.3],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // === OBJETS COLLECTIBLES ===
    {
      id: 'obj_pipe',
      name: 'Pipe de Gandalf',
      type: 'interactive',
      modelId: 'pot',
      position: [7, 0.3, 5],
      rotation: [0.3, 0.5, 0],
      scale: [0.5, 0.5, 0.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'gandalf_pipe',
            itemName: 'Pipe de Gandalf',
            itemDescription: "La célèbre pipe de Gandalf. L'herbe à pipe de la Comté est la meilleure.",
            itemIcon: 'scroll',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Vous trouvez la pipe de Gandalf ! Elle sent encore l'Herbe à Pipe du Quartier Sud.",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_pipe' },
        },
      ],
    },

    // Épée Dard
    {
      id: 'obj_sting',
      name: 'Dard',
      type: 'interactive',
      modelId: 'weapon_rack',
      position: [6, 0, 7],
      rotation: [0, 0.2, 0],
      scale: [0.8, 0.8, 0.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'sting',
            itemName: 'Dard',
            itemDescription: "L'épée elfique de Frodon. Elle brille d'une lueur bleue quand des Orques sont proches.",
            itemIcon: 'star',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Vous avez trouvé Dard, l'épée elfique !",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_sting' },
        },
      ],
    },

    // Fleurs de la Comté
    {
      id: 'obj_flowers_1',
      name: 'Fleurs',
      type: 'static',
      modelId: 'flower',
      position: [5, 0, 8],
      rotation: [0, 0, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { color: 'yellow' },
    },
    {
      id: 'obj_flowers_2',
      name: 'Fleurs',
      type: 'static',
      modelId: 'flower',
      position: [14, 0, 6],
      rotation: [0, 0.5, 0],
      scale: [1.3, 1.3, 1.3],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { color: 'white' },
    },
  ],
  puzzles: [],
  connections: [],
  initialWorld: 'real',
  hasSpectralLayer: true,
  palette: 'forest',
  biome: 'forest',
  weather: 'none',
  weatherIntensity: 0.3,
  npcs: [
    // === MONDE REEL - PERSONNAGES AMICAUX ===
    {
      id: 'npc_hobbit_frodo',
      type: 'hobbit',
      name: 'Frodon',
      position: [7, 0, 6],
      scale: 3,
      idleAnimation: 'stand',
      petAnimation: 'happy',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_hobbit_sam',
      type: 'hobbit',
      name: 'Sam',
      position: [9, 0, 5],
      scale: 3,
      idleAnimation: 'stand',
      petAnimation: 'happy',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_gandalf',
      type: 'gandalf',
      name: 'Gandalf le Gris',
      position: [10, 0, 10],
      scale: 4,
      idleAnimation: 'stand',
      petAnimation: 'nuzzle',
      petRadius: 3,
      petCooldown: 3000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_ent',
      type: 'ent',
      name: 'Sylvebarbe',
      position: [18, 0, 12],
      scale: 5,
      idleAnimation: 'stand',
      petAnimation: 'happy',
      petRadius: 4,
      petCooldown: 5000,
      isPettable: true,
      visibleInWorld: 'real',
    },

    // === MONDE SPECTRAL - FORCES DU MAL ===
    {
      id: 'npc_nazgul_1',
      type: 'nazgul',
      name: 'Nazgûl',
      position: [8, 0, 16],
      scale: 4,
      idleAnimation: 'stand',
      petAnimation: 'roar',
      petRadius: 4,
      petCooldown: 8000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_nazgul_2',
      type: 'nazgul',
      name: 'Roi-Sorcier',
      position: [16, 0, 14],
      rotation: [0, -Math.PI / 3, 0],
      scale: 5,
      idleAnimation: 'stand',
      petAnimation: 'roar',
      petRadius: 5,
      petCooldown: 10000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_orc_1',
      type: 'orc',
      name: 'Orque',
      position: [6, 0, 14],
      scale: 3,
      idleAnimation: 'prowl',
      petAnimation: 'growl',
      petRadius: 2.5,
      petCooldown: 4000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_orc_2',
      type: 'orc',
      name: 'Orque',
      position: [18, 0, 6],
      scale: 2.8,
      idleAnimation: 'prowl',
      petAnimation: 'growl',
      petRadius: 2.5,
      petCooldown: 4000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_balrog',
      type: 'balrog',
      name: 'Balrog de Morgoth',
      position: [12, 0, 20],
      rotation: [0, Math.PI, 0],
      scale: 6,
      idleAnimation: 'idle',
      petAnimation: 'roar',
      petRadius: 6,
      petCooldown: 15000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
  ],
};
